import apiClient, { API_BASE_URL } from "./apiClient";

const api = apiClient;

if (process.env.NODE_ENV === "development") {
  console.log("API baseURL configurada:", API_BASE_URL);
}

/**
 * Testa a conectividade com o MongoDB através da API
 * @returns {Promise<Object>} Resultado do teste de conectividade
 */
export const testMongoDBConnectivity = async () => {
  try {
    if (process.env.NODE_ENV === "development") {
      console.log("Testando conectividade com MongoDB...");
    }

    const response = await api.get("/connectivity-test");
    const result = response.data;

    // Analisar o resultado apenas em desenvolvimento
    if (process.env.NODE_ENV === "development") {
      if (result.mongodb && result.mongodb.connected) {
        if (result.mongodb.operationSuccess) {
          console.log(`MongoDB conectado e respondendo em ${result.mongodb.responseTime}ms`);
        } else {
          console.warn("MongoDB conectado, mas operacao de ping falhou");
        }
      } else {
        console.error("MongoDB nao esta conectado");
      }

      // Verificar coleção de usuários
      if (result.usersCollection) {
        if (result.usersCollection.success) {
          console.log(`Colecao de usuarios verificada (${result.usersCollection.count} usuarios)`);
        } else {
          console.warn(`Problema com colecao de usuarios: ${result.usersCollection.error}`);
        }
      }

      // Mostrar recomendações apenas se necessário
      if (result.uriAnalysis?.recommendations?.length > 0 &&
        (!result.mongodb.connected || !result.mongodb.operationSuccess)) {
        console.warn("Recomendacoes para conexao MongoDB:");
        result.uriAnalysis.recommendations.forEach(rec => {
          console.warn(`   - ${rec}`);
        });
      }
    }

    return result;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error("Erro ao testar conectividade:", error.message);
    }

    // Retornar um resultado padrão de erro ao invés de throw
    return {
      mongodb: { connected: false, error: error.message },
      usersCollection: { success: false, error: error.message },
      timestamp: new Date().toISOString()
    };
  }
};

export default api;
